module.exports = __webpack_public_path__ + "img/8399bf0a79e44ed4a96b14a6af420311.png";